/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartTools',[
    'jquery',    
    'global/all',
    './CartManager',
    'global/RocAnalytics',
    'modules/Store/StorePermissionService'
], function ($, Roc, CartManager, RocAnalytics, StorePermissionService) {
    'use strict';

    var checkoutUrl = '';
    var savedCartsUrl = '';
    var punchoutOrder;

    var btns = {
        proceedCheckout: '#btnProceedCheckoutTop',
        viewCart: '#viewCartBtn',
        saveCart: '#saveCartBtn',
        requestQuote: '#btnRequestQuote',
        clearCart: "[data-roc-action='clearCart']"
    };

    /* Events */
    function openSaveCartModalEvt() {
        $(document).on('click', '.openSaveCartModal', function () {
            Roc.UI.Modal.open('#saveCartModal');
        });
    }

    function saveCartEvt() {
        $(document).on('click', btns.saveCart, function () {
            var $form = $('#saveCartModal');

            var requestData = {
                Email: null,
                CartName: null
            };

            //TODO: refactor to use forms
            var validationMsg = '';
            var $cartName = $form.find('input[name="cartName"]');
            if ($cartName.val().length === 0) {
                validationMsg += 'Please enter cart name';
            } else {
                requestData.CartName = $cartName.val();
            }

            var $email = $form.find('input[name="email"]');
            if ($email.length === 1) {
                var regEx = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/;
                if (regEx.test($email.val())) {
                    requestData.Email = $email.val();
                } else {
                    validationMsg += 'Please enter valid email address';
                }
            }

            if (validationMsg.length > 0) {
                Roc.UI.displayErrorPopup(validationMsg);
            } else {
                CartManager.saveOrder(requestData.CartName, requestData.Email);
                Roc.Core.lockButton(btns.saveCart);
            }
        });
    }

    function viewSavedCartEvt() {
        $(document).on('click', btns.viewCart, $.proxy(function () {
            var redirectUrl = savedCartsUrl;
            var email = $('#viewCartModal input[name="email"]').val();
            var regEx = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/;
            if (regEx.test(email)) {
                Roc.UI.Modal.close();

                redirectUrl += '?Email=' + encodeURIComponent(email);
                window.location.replace(redirectUrl);
                Roc.Core.lockButton(btns.viewCart);
            } else {
                Roc.UI.displayErrorPopup('There seems to be a problem with the email address. Please enter a valid email address and try again.');
            }
        }, this));
    }

    function viewSavedCartsModalEvt() {
        $(document).on('click', '.viewSavedCartsBtn', function () {
            Roc.UI.Modal.open('#viewCartModal');
        });
    }

    function changeVisibility(selector, show) {
        if (show) {
            $(selector).removeClass('hidden');
        } else {
            $(selector).addClass('hidden');
        }
    }
    //Customization: added button to clear cart
    function clearCartEvt() {
        $(document)
            .on('click',
                btns.clearCart,
                function () {
                    Roc.UI.confirm({
                        "title": 'Clear Cart',
                        "message":
                            'Are you sure you want to clear your current cart?',
                        "buttons": {
                            "Yes": {
                                "class": 'btn btnAction confirm clearCartButton',
                                "autoClose": false,
                                "action": function () {
                                    Roc.Core.lockButton('.clearCartButton');
                                    $.ajax({
                                        url: '/ajax/ClearCurrentCart',
                                        type: 'POST',
                                        contentType: 'application/json',
                                        dataType: 'json'
                                    })
                                    .then(function () {
                                        window.location.reload();
                                    })
                                    .fail(function() {
                                        Roc.UI.displayErrorPopup("Could not clear your cart. Please try again or contact administrator")
                                    })
                                    .always(function () {
                                        $('.closeClearCartModal').trigger('click');
                                    });
                                }
                            },
                            "Cancel": {
                                "class": 'btn closeClearCartModal',
                                "action": function () {

                                }
                            }
                        }
                    });
                });
    }

    function updateTools(cart) {
        // customizations: Checkout button gets hidden if the current shopping cart is flagged as Quote Only.
        if (cart !== undefined && cart !== null && cart.items !== undefined && cart.items !== null ) {
            var totalItems = cart.items.length;
            if (totalItems === 0) {
                changeVisibility('li.saveCart', false);
            } else {
                changeVisibility('li.saveCart', true);
            }

            var canCheckout = StorePermissionService.canCheckout(cart);
            var canRequestQuote = StorePermissionService.canRequestQuote(cart);

            changeVisibility(btns.proceedCheckout, canCheckout);
            changeVisibility(btns.requestQuote, canRequestQuote);
        }
    }

    function canCheckoutOrRequestQuote() {
        return $.ajax();
    }

    function saveOrderItem(orderItemId) {
        CartManager.saveOrderItem(orderItemId);
    }

    function afterOrderCartSaved(data) {
        if (data.success) {
            var redirectUrl = savedCartsUrl;

            // close currently open modal
            Roc.UI.Modal.close();

            if ('Email' in data) {
                redirectUrl += '?Email=' + encodeURIComponent(data.Email);
            }
            window.location.replace(redirectUrl);
        } else {
            Roc.Core.releaseLockButton('saveCartBtn');
        }
    }

    function emailCartModal() {
        Roc.UI.Modal.open('#emailCartModal');
    }

    function emailCart(url) {
        var email = $('#emailCartModal input[name="email"]').val();
        var regEx = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/;
        if (regEx.test(email)) {
            $.ajax({
                type: 'POST',
                url: url + '/EmailCart',
                data: JSON.stringify({
                    'email': email
                }),
                contentType: 'application/json; charset=utf-8'
            }).done(function (response) {
                if (response && response.success === true) {
                    Roc.UI.Modal.close();
                } else {
                    Roc.UI.displayErrorPopup();
                }
            }).fail(function (xhr) {
                Roc.UI.ajaxErrorPopup(xhr);
            });

        } else {
            Roc.UI.displayErrorPopup('There seems to be a problem with the email address. Please enter a valid email address and try again.');
        }
    }

    function bindEvents() {
        openSaveCartModalEvt();
        saveCartEvt();
        viewSavedCartsModalEvt();
        viewSavedCartEvt();
        //Customization: added button to clear cart
        clearCartEvt();
        Roc.EventManager.bind(Roc.Events.cart.CART_SAVED, afterOrderCartSaved);
        //Customizations: cart tools are updated when GET_CURRENT_CART event is triggered
        //Roc.EventManager.bind(Roc.Events.cart.GET_SUMMARY, updateTools);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, updateTools);
    }

    function init(options) {
        savedCartsUrl = options.savedCartsUrl;
        checkoutUrl = options.checkoutUrl;
        punchoutOrder = options.punchoutOrder;
        bindEvents();
    }

    var CartTools = {
        init: init,
        emailCart: emailCart,
        emailCartModal: emailCartModal,
        afterOrderCartSaved: afterOrderCartSaved,
        saveOrderItem: saveOrderItem,
        updateTools: updateTools
    };

    Roc.Logger.debug('CartTools.js Loaded:', CartTools);

    return CartTools;
});
